module.exports = require("plugin-wells/shared/components/InterventionTypeSelect");